import React, { useEffect, useState, useContext, useRef } from 'react';
import { xs_isMobile, xs_sessionToken } from '../../..';
import { getMyBets } from '../../../data/fetchMyBets';
import { getLabel } from '../../../data/labels';
import { CashoutConfigurationContext } from '../../cashout/CashoutConfigurationCtx';
import { addDaysToDate } from '../../utils/addDaysToDate';
import { classIf } from '../../utils/classIf';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getDBTimestampFromDate } from '../../utils/getDBTimestampFromDate';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { getQueryStringToken } from '../../utils/getQueryStringToken';
import { getQueryStringVariable } from '../../utils/getQueryStringVariable';
import MultipleBetsTicket from './MultipleBetsTicket';
import SingleBetTicket from './SingleBetTicket';
import SystemBetsTicket from './SystemBetsTicket';
import CssCounter from '../../betslip/CssCounter';
import Legend from './Legend';
import { cashoutTicket, startCashoutPolling } from '../../purchase-service';
import $ from 'jquery';
import Loader from '../../../common/Loader';
import { MyBetsContext } from './MyBetsContext';
import { getEnv } from '../../env';

window.unlockMyBets = function () {
	$('#cg-mybet-body').removeClass('pointerNone');
	$('#cg-mybet-body').removeClass('shadowBetting');
}
window.lockMyBets = function () {
	$('#cg-mybet-body').addClass('pointerNone');
	$('#cg-mybet-body').addClass('shadowBetting');
}

function getDateRange(myBetsType) {
	const conf = getConfiguration();
	const today = new Date();
	const daysOffset   = conf.dfmb || 13;
	let dateRange = {'dateFrom':null,
				     'dateTo':null
					};
	try {
		dateRange.dateFrom = getDBTimestampFromDate(addDaysToDate(today,(daysOffset*-1))).substring(0,8);
		dateRange.dateTo = getDBTimestampFromDate(today).substring(0,8);
	} catch(err) {
		console.log(err);
	}

	return dateRange;
}

function getTicketCategoryFromTab(currentType) {
	switch (currentType) {
		case 1:  return getLabel('mybets.tipo.live', 'Live');
		case 2:  return getLabel('mybets.tipo.incorso', 'In corso');
		case 3:  return getLabel('mybets.tipo.concluse', 'Concluse');
		case 4:  return 'Cashout';
		default: return getLabel('mybets.tipo.incorso',  'In corso');
	}
}

function MyBetsLayout2(props) {
	const ctxs = useRef({}).current;
	const conf = getConfiguration();
    const [currentType, setCurrentType] = useState(2);
    const [toggledTicket, setToggledTicket] = useState(null);
	const dateRange = getDateRange(currentType);
	const dateFrom = getQueryStringVariable('dateFrom') || dateRange.dateFrom;
	const dateTo = getQueryStringVariable('dateTo') || dateRange.dateTo;
 	const cashoutConfigurationContext = useContext(CashoutConfigurationContext);
    const [myBetsContext, setMyBetsContext] = useState({
   	    data: null,
    	sessionToken: props.sessionToken || getQueryStringToken() || '',
    	pollingEnabled: true,
    	lockMyBetsSection: false,
    	pollingIntervalId: null,
    	cashoutTimer: false,
    	acceptCashoutAmountVariation: false,
    	cashoutPopupState: {shown:false, title:null, text:null, showBackButton:false, nextFunction:() => {}, isLive: false},
    	update: function(updt) {
			// updating temporary
			for(let ko in updt) {
				const val = updt[ko];
				ctxs.myBetsContext[ko] = val;
			}
			//update effectly
			setMyBetsContext(prev => {
                return {...prev, ...updt};
            });
        },
    	loadMyBets: function() {
    		getMyBets(ctxs.myBetsContext.sessionToken, dateFrom, dateTo, (parsedData) => {
    			ctxs.myBetsContext.update({data: parsedData});
    		}, () => {});

    	},
    	disablePolling: function() {
			clearInterval(ctxs.myBetsContext.pollingIntervalId);
    		ctxs.myBetsContext.update({pollingEnabled: false});
    	},
    	enablePolling: function() {
    		ctxs.myBetsContext.update({pollingEnabled: true});
    	},
    	lockMyBets: function () {
	    	ctxs.myBetsContext.update({lockMyBetsSection: true});
    	},
    	unlockMyBets: function () {
			ctxs.myBetsContext.update({lockMyBetsSection: false});
    	},
    	setCashoutTimer: function (value) {
    		 ctxs.myBetsContext.update({cashoutTimer: value});
    	},
    	setCashoutPopupState: function(cashoutPopupState) {
	    	ctxs.myBetsContext.update({cashoutPopupState});  		
    	},
    	showPreCashoutDisclaimer: function(ticketId, amount, cashoutAmount, isLive) {
    		const printableCashoutAmount = getPrintableAmount(cashoutAmount, conf.cs.m, conf.cs.nd);
    		const amountWithCurrency = `${printableCashoutAmount} ${getCurrencySymbol(conf.cs.ct)}`;
    		let disclaimerCashoutPre = getLabel('cashout.disclaimer_pre');
        	disclaimerCashoutPre = disclaimerCashoutPre.replace(/{{TICKET_ID}}/g, ticketId);
        	disclaimerCashoutPre = disclaimerCashoutPre.replace(/{{AMOUNT}}/g, amountWithCurrency);
        	function nextFunction() {
        		ctxs.myBetsContext.goCashout(ticketId, amount, cashoutAmount);
        	}
        	ctxs.myBetsContext.setCashoutPopupState({shown:true, title:getLabel('cashout.popup_title'), text:disclaimerCashoutPre, showBackButton:true, isLive, type:"pre-transaction", nextFunction: nextFunction});    	
    	},
    	    
    	showCashoutResult: function (ticketId, cashoutAmount, purchaseAmount, response) {
	    	const resultCode = (response.returnCode.code == 0 || response.returnCode.code == 1024)? 0: response.returnCode.code;
		    const newCashoutAmount = response.amountWin;
	    	if(resultCode === -5454 && cashoutAmount != newCashoutAmount) {
	    		if(ctxs.myBetsContext.acceptCashoutAmountVariation) {
		    		// automatic new cashout transaction
		    		const fatherTransactionId = response.transactionIDString;
		    		ctxs.myBetsContext.goCashout(ticketId, purchaseAmount, newCashoutAmount, fatherTransactionId);	    		
	    		}
	    		else{
	    			ctxs.myBetsContext.showPreCashoutDisclaimer(ticketId, purchaseAmount, newCashoutAmount, true);
	    		}
	    		return;
	    	}
	    	const amount = getPrintableAmount(cashoutAmount, conf.cs.m, conf.cs.nd);
    		const amountWithCurrency = `${amount} ${getCurrencySymbol(conf.cs.ct)}`;
	    	let cashoutResultText = '';
	    	const title = getLabel('cashout.popup_title');
	    	if (resultCode === 0) {
	    		cashoutResultText = getLabel('cashout.success');
	    		cashoutResultText = cashoutResultText.replace(/{{ID_TICKET}}/g, ticketId);
	    		cashoutResultText = cashoutResultText.replace(/{{AMOUNT}}/g, amountWithCurrency);
	    	} 
	    	else {
	    		cashoutResultText = `[${resultCode}] ${response.returnCode.description}`;
	    	}
	        ctxs.myBetsContext.setCashoutPopupState({shown:true, title, text: cashoutResultText, showBackButton:false, nextFunction: ctxs.myBetsContext.hideCashoutPopup});
    		ctxs.myBetsContext.update({acceptCashoutAmountVariation: false})
    	},
    	hideCashoutPopup: function() {
    		ctxs.myBetsContext.unlockMyBets();
    		ctxs.myBetsContext.enablePolling();
    		ctxs.myBetsContext.setCashoutPopupState({shown:false, title:null, text:null, showBackButton:false, isLive:false, nextFunction:() => {}});
    	},
    	goCashout: function (ticketId, amount, cashoutAmount, fatherTransactionId) {
	    	ctxs.myBetsContext.lockMyBets();
	    	ctxs.myBetsContext.disablePolling();
			ctxs.myBetsContext.setCashoutPopupState({shown:false, title:null, text:null, showBackButton:false, nextFunction:() => {}});
			function startTimerOperations(timerData) {
				ctxs.myBetsContext.unlockMyBets();
				ctxs.myBetsContext.setCashoutTimer(timerData.delay);
			}
		
			function handleResponseCallback(res) {
		  		ctxs.myBetsContext.setCashoutTimer(false);
		  		ctxs.myBetsContext.showCashoutResult(ticketId, cashoutAmount, amount, res);
			}
			function errorCallback(error) {
                const cashoutRequestData = JSON.parse(localStorage.getItem('CASHOUT_REQUEST_DATA'));
				ctxs.myBetsContext.unlockMyBets();
				ctxs.myBetsContext.setCashoutTimer(cashoutRequestData.delay);
				ctxs.myBetsContext.setCashoutPopupState({shown:true, title: getLabel('cashout.popup_title'), text: error, showBackButton:false, nextFunction: ctxs.myBetsContext.hideCashoutPopup});		
			}
		
	    	cashoutTicket(xs_sessionToken, ticketId, amount, cashoutAmount, 5, null, startTimerOperations, handleResponseCallback, errorCallback, fatherTransactionId);
    	},
    	toggleCashoutAmountVariation: function() {
    		const acceptCashoutAmountVariation = !ctxs.myBetsContext.acceptCashoutAmountVariation;
    		ctxs.myBetsContext.update({acceptCashoutAmountVariation});
    	}
    });
    ctxs.myBetsContext = myBetsContext;

	useEffect(() => {
		const version = getEnv('REACT_APP_FRONTEND_VERSION');
		const systemCodeEnv= getEnv('REACT_APP_SYSTEM_CODE')
		// da mettere in configurazione o cambiare strategia...
		if (systemCodeEnv !== 'SPORTBET' && ( version === 'starcasino' || version === 'betsson')   ) {
			import('./starcasino.min.css');
		} else {
			import('./my-bets.min.css');
		}
	}, []);

    useEffect(() => {
    	if (!ctxs.myBetsContext.pollingEnabled) {
    		clearInterval(ctxs.myBetsContext.pollingIntervalId);
    	} else {
    		ctxs.myBetsContext.loadMyBets();
    		const intervalMillis = conf.ctp? conf.ctp: 10000;
            if (intervalMillis > 0) {
            	ctxs.myBetsContext.pollingIntervalId = setInterval(() => {
                	ctxs.myBetsContext.loadMyBets();
                }, intervalMillis);
            }
    	}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctxs.myBetsContext.pollingEnabled]);

    useEffect(() => {
    	if (localStorage.getItem('CASHOUT_REQUEST_DATA')) {
    		const cashoutRequestData = JSON.parse(localStorage.getItem('CASHOUT_REQUEST_DATA'));
    		ctxs.myBetsContext.disablePolling();
    		ctxs.myBetsContext.setCashoutTimer(cashoutRequestData.delay);
    		setTimeout(() => {
        		startCashoutPolling(cashoutRequestData.transactionId, cashoutRequestData.idTicket, (response) => {
        			ctxs.myBetsContext.setCashoutTimer(false);
        			ctxs.myBetsContext.showCashoutResult(cashoutRequestData.idTicket, cashoutRequestData.cashoutAmount, response);
        		}, 
        		(error) => {
        			ctxs.myBetsContext.setCashoutTimer(cashoutRequestData.delay);
        			ctxs.myBetsContext.unlockMyBets();
					ctxs.myBetsContext.setCashoutPopupState({shown:true, title: getLabel('cashout.popup_title'), text: error, showBackButton:false, nextFunction: myBetsContext.hideCashoutPopup.hideCashoutPopup});	
        		});
        	}, cashoutRequestData.delay * 1000);
    	}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

	useEffect(() => {
    	if (xs_isMobile && document.querySelector("#xsport-container #my-bets-container")) {
			const boundRectMenu = document.querySelector(".cg-menuTabMobile").getBoundingClientRect();
			document.querySelector("#xsport-container #my-bets-container").style.paddingBottom = `${boundRectMenu.height}px`;
		}
    	window.simulateCashoutTimer = function(timer) {
			ctxs.myBetsContext.setCashoutTimer(timer);
		}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    });
	
	useEffect(() => {
        return () =>{
            ctxs.myBetsContext.disablePolling();
        }
		 // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    function toggleTicket(ticketId) {
        if (ticketId === toggledTicket) {
            setToggledTicket(null);
        } else {
            setToggledTicket(ticketId);
        }
    }

    const cashoutEnabled = cashoutConfigurationContext.cashoutData.enabled;

    let tickets = null;
    if (myBetsContext.data) {
    	switch (currentType) {
			default:
			case 1:
				tickets = myBetsContext.data.live;
				break;
			case 2:
				tickets = myBetsContext.data.open;
				break;
			case 3:
				tickets = myBetsContext.data.ended;
				break;
			case 4:
				tickets = myBetsContext.data.cashout;
				break;
    	};    	
    }

	let myBetsClass = 'cg-mybet-section';
	if (ctxs.myBetsContext.lockMyBetsSection) {
		myBetsClass += ' shadowMyBet';
	} else if(ctxs.myBetsContext.cashoutTimer) {
		myBetsClass += ' shadowBetting';
	}

	if (conf.iwh && myBetsContext.data === null) {
		return <Loader />;
	}

	const ticketCategory = getTicketCategoryFromTab(currentType);

    return (
		<MyBetsContext.Provider value={ctxs.myBetsContext}>
			<div id="xs-my-bets-layout-2">
				{ctxs.myBetsContext.cashoutTimer && <div className="loader-cart"> <CssCounter label={getLabel('cashout.wait_live_delay')} seconds={ctxs.myBetsContext.cashoutTimer} /> </div>}
				{myBetsContext.cashoutPopupState.shown &&
					<div className="customPopup cashout">
						<div className="customPopup__content">
							<div className="customPopup__content__header">
								<div className="customPopup__content__header__title">
									<p>{myBetsContext.cashoutPopupState.title}</p>
								</div>
								<button className="customPopup__content__header__closeButton" onClick={() => ctxs.myBetsContext.hideCashoutPopup()}>
									<i className="fas fa-times"></i>
								</button>
							</div>
							<div className="customPopup__content__body cashout">
								<p>{ctxs.myBetsContext.cashoutPopupState.text}</p>
								{ctxs.myBetsContext.cashoutPopupState.isLive && ctxs.myBetsContext.cashoutPopupState.type === 'pre-transaction' &&
									<div className="cashoutVariationToggleContainer">
										<label className="custom-switch-2 mr-2">
											<input id="amountVar" type="checkbox" onChange={(e) => ctxs.myBetsContext.toggleCashoutAmountVariation()} checked={ctxs.myBetsContext.acceptCashoutAmountVariation} />
											<span className="custom-slider-2 round"></span>
										</label>
										<span>{getLabel('cashout.amount_variation_toggle')}</span>
									</div>
								}
								<div className="cashoutButtonContainer">
									{ctxs.myBetsContext.cashoutPopupState.showBackButton &&
										<button onClick={() => ctxs.myBetsContext.hideCashoutPopup()} className="bottone cashout bg-rosso bianco maiuscolo">
											{getLabel('general.back')} 
										</button>
									}
									<button onClick={() => ctxs.myBetsContext.cashoutPopupState.nextFunction()} className="bottone cashout bg-verde bianco maiuscolo">
										{getLabel('general.next')}  
									</button>
								</div>
							</div>
						</div>
					</div>
				}
				{ctxs.myBetsContext.data != null &&
					<div id="cg-mybet-body" className={myBetsClass}>
						<nav className="nav-slider d-flex | mb_1" id="my-bets-navbar">
							<div className={"nav-slider-item-container pointer | mb_1_1" + classIf(currentType === 1, 'selected')} onClick={() => setCurrentType(1)}>
								<span className="nav-slider-item bold | mb_1_1_1">{getLabel('mybets.tipo.live')}</span>
								<span className="circle | mb_1_1_2">{ctxs.myBetsContext.data.live.length}</span>
							</div>
							<div className={"nav-slider-item-container pointer | mb_1_1" + classIf(currentType === 2, 'selected')} onClick={() => setCurrentType(2)}>
								<span className="nav-slider-item bold | mb_1_1_1">{getLabel('mybets.tipo.incorso')}</span>
								<span className="circle | mb_1_1_2">{ctxs.myBetsContext.data.open.length}</span>
							</div>
							<div className={"nav-slider-item-container pointer | mb_1_1" + classIf(currentType === 3, 'selected')} onClick={() => setCurrentType(3)}>
								<span className="nav-slider-item bold | mb_1_1_1">{getLabel('mybets.tipo.concluse')}</span>
								<span className="circle | mb_1_1_2">{ctxs.myBetsContext.data.ended.length}</span>
							</div>
							{cashoutEnabled &&
								<div className={"nav-slider-item-container pointer | mb_1_1" + classIf(currentType === 4, 'selected')} onClick={() => setCurrentType(4)}>
									<span className="nav-slider-item bold | mb_1_1_1">{'Cashout'}</span>
									<span className="circle | mb_1_1_2">{ctxs.myBetsContext.data.cashout.length}</span>
								</div>
							}
						</nav>
						<div id="my-bets-container" className="mb_2">
							{tickets.length > 0 ?
								<>
									{tickets.map(ticket => {
										switch (ticket.type) {
											default:
											case 'singlebets':
												return <SingleBetTicket key={ticket.id} ticket={ticket} toggled={ticket.id === toggledTicket} toggleTicket={toggleTicket} ticketCategory={ticketCategory}/>
											case 'multibets':
												return <MultipleBetsTicket key={ticket.id} ticket={ticket} toggled={ticket.id === toggledTicket} toggleTicket={toggleTicket} ticketCategory={ticketCategory}/>
											case 'systembets':
												return <SystemBetsTicket key={ticket.id} ticket={ticket} toggled={ticket.id === toggledTicket} toggleTicket={toggleTicket} ticketCategory={ticketCategory}/>
										}
									})}
								</>
								:
								<div className="d-flex justify-content-center align-items-center | mb_11">
									<p className="text-big margin-top-10pc margin-bottom-auto | mb_11_1">{getLabel('mybets.nessunascommessa')}</p>
								</div>
							}
						</div>
						<Legend />
					</div>
				}
			</div>
		</MyBetsContext.Provider>
    );
}

export default MyBetsLayout2;